<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
      <v-row no-gutters>
        <v-col cols="12">
          <DataTable
            @editing="editing"
            @deleting="deleting"
            :title="''"
            :headers="headers"
            :items="quizzes"
            :search="search"
          />
        </v-col>
        <Dialogbox
          @closing="closing"
          @deleteuser="deleteQuiz"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :deleteuser="true"
          v-if="dialogstatus"
        />
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2" @click="addQuiz">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_QUIZ,
  DELETE_QUIZ,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "Quiz",
  beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE)
    store.dispatch(FETCH_QUIZ, "").then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "Quiz",
      search: "",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,
      quiz_id: null,
      singleSelect: "",
      dialog: false,
    };
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Dialogbox: () => import("@/components/dialog/dialog"),
    Header: () => import("@/components/header/Header")
  },
  computed: {
    ...mapGetters(["quizzes",'currentUser']),
    headers () {
      return [
        { text: this.$t("Quiz id"), value: "quiz_id" },  
        { text: this.$t("Name"), value: "quiz_name" },        
        { text: this.$t("Description"), value: "quiz_description" },        
        { text: this.$t("Language"), value: "quiz_language" },        
        { text: this.$t("Actions"), value: "action", sortable: false }
      ]
    }
  },
  created (){
    if(this.currentUser.roles.includes(1) == false){
      this.$router.push('/dashboard');
    }
  },
  methods: {
    addQuiz() {
      this.$router.push("/quiz/add");
    },
    editing(id) {
      this.$router.push("/quiz/edit/" + id)
    },
    deleting(id) {
      this.dialogstatus = true
      this.dialogboxtitle = "Are you sure want to remove?"
      this.dialogButtontitle = "Remove"
      this.quiz_id = id
    },
    async deleteQuiz() {
      await this.$store
        .dispatch(DELETE_QUIZ, this.quiz_id)
        .then(async resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.quiz_id = null;
            await store.dispatch(FETCH_QUIZ, "").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
            });
          }
          else{
            store.commit(SET_LOADING, false);
          }
        });
    },
    closing() {
      this.dialogstatus = false
    },
  }
};
</script>